<template>
    <div>
        <h4 class="mb-6">IPTV Sources</h4>
        <sources-table sources-u-r-l="/api/management/v1/source/" :marked-sources="inUse"/>
    </div>
</template>
<script>

    import SourcesTable from './SourcesTable'
    export default {
        components: { SourcesTable },
        data() {
            return {
                inUse: []
            }
        },
        methods: {
            loadSourcesInUse() {
                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/source/?inUse=true')
                loadPromise.then(function(response) {
                    thisIns.inUse = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })
            }
        },
        mounted() {
            this.loadSourcesInUse()
        }
    }

</script>
